import React, { useState, useEffect } from "react";
import { Modal, Button, ListGroup, Spinner, Row, Col } from "react-bootstrap";
import axios from "axios";
import { toast } from "react-toastify";

function TradeLicenseDetailsModal({ show, handleClose, licenseId }) {
  const [details, setDetails] = useState(null);
  const [loading, setLoading] = useState(false);

  const API_URL = process.env.REACT_APP_SUPER_ADMIN_API_URL;
  const token = localStorage.getItem("token");

  useEffect(() => {
    const fetchDetails = async () => {
      if (licenseId && show) {
        setLoading(true);
        try {
          const response = await axios.get(
            `${API_URL}get-trade-licence.php?id=${licenseId}`,
            {
              headers: { Authorization: `Bearer ${token}` },
            }
          );
          if (response.data.success && response.data.data) {
            setDetails(response.data.data);
          } else {
            toast.error("Could not fetch license details.");
            handleClose();
          }
        } catch (error) {
          toast.error("Failed to fetch license details.");
          handleClose();
        } finally {
          setLoading(false);
        }
      }
    };

    fetchDetails();
  }, [licenseId, show, API_URL, token, handleClose]);

  return (
    <Modal show={show} onHide={handleClose} centered size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Trade License Full Details</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {loading ? (
          <div className="text-center p-5">
            <Spinner animation="border" />
          </div>
        ) : details ? (
          <ListGroup variant="flush">
            <Row>
              <Col md={6}>
                <ListGroup.Item>
                  <strong>Trade Name:</strong> {details.trade_name}
                </ListGroup.Item>
              </Col>
              <Col md={6}>
                <ListGroup.Item>
                  <strong>Owner Name:</strong> {details.trade_owner}
                </ListGroup.Item>
              </Col>
              <Col md={12}>
                <ListGroup.Item>
                  <strong>Address:</strong> {details.address}
                </ListGroup.Item>
              </Col>
              <Col md={6}>
                <ListGroup.Item>
                  <strong>Holding No:</strong> {details.holding_no || "N/A"}
                </ListGroup.Item>
              </Col>
              <Col md={6}>
                <ListGroup.Item>
                  <strong>Phone No:</strong> {details.phone}
                </ListGroup.Item>
              </Col>
              <Col md={6}>
                <ListGroup.Item>
                  <strong>Trade Type:</strong> {details.trade_type_name}
                </ListGroup.Item>
              </Col>
              <Col md={6}>
                <ListGroup.Item>
                  <strong>Approx Area:</strong> {details.approx_area} sq. ft.
                </ListGroup.Item>
              </Col>
              <Col md={6}>
                <ListGroup.Item>
                  <strong>Registration No:</strong> {details.reg_no || "N/A"}
                </ListGroup.Item>
              </Col>
              <Col md={6}>
                <ListGroup.Item>
                  <strong>Registration Date:</strong>{" "}
                  {details.reg_date && details.reg_date !== "0000-00-00"
                    ? details.reg_date
                    : "N/A"}
                </ListGroup.Item>
              </Col>
              <Col md={6}>
                <ListGroup.Item>
                  <strong>Expire Date:</strong>{" "}
                  {details.expire_date && details.expire_date !== "0000-00-00"
                    ? details.expire_date
                    : "N/A"}
                </ListGroup.Item>
              </Col>
            </Row>
          </ListGroup>
        ) : (
          <p>No details found.</p>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default TradeLicenseDetailsModal;
